module.exports = __webpack_public_path__ + "static/media/logosvg.fe859ac8.svg";